import { JsonObject, JsonProperty } from 'typescript-json-serializer';

import PresetFormField, { referenceType } from 'domain/entity/preset/form/presetFormField';
import { getTypes } from 'adapter/out/serializer';

@JsonObject()
class PresetForm {
    constructor(
        @JsonProperty()
        readonly type: string,
        @JsonProperty({ type: getTypes(referenceType), required: true })
        readonly fields: PresetFormField[]
    ) {}
}

export default PresetForm;
